var React = require('react');

function LinkArrow (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M15.584 11.8496L11.9173 8.18294","stroke":"#FCEC92","strokeWidth":"1.3","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M15.584 11.8497L11.9173 15.5164","stroke":"#FCEC92","strokeWidth":"1.3","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M6.41667 11.8496L15.125 11.8496","stroke":"#FCEC92","strokeWidth":"1.3","strokeLinecap":"round","key":2}),React.createElement("path",{"d":"M11 3.59961C6.44365 3.59961 2.75 7.29326 2.75 11.8496C2.75 16.406 6.44365 20.0996 11 20.0996C15.5563 20.0996 19.25 16.406 19.25 11.8496C19.25 7.29326 15.5563 3.59961 11 3.59961Z","stroke":"#FCEC92","strokeWidth":"1.3","strokeLinecap":"round","key":3})]);
}

LinkArrow.defaultProps = {"width":"22","height":"23","viewBox":"0 0 22 23","fill":"none"};

module.exports = LinkArrow;

LinkArrow.default = LinkArrow;
